module.exports = {
  DELIVERY_ADDRESS_BOOK: 0,
  RETURN_ADDRESS_BOOK: 1,
  SHIPMENT: 2,
  SHIPMENT_RECEIPT: 3,
  SHIPMENT_EXPORT: 4,
  DPD_DIRECT_PRODUCT: 5,
  RELEASE_FILE: 6,
  PRODUCT: 7,
};
